export enum SessionType {
  RelatedServicesAppointment = 1,
  IEPMeetingAttendance = 2,
  NYCPSAuthorizedTraining = 3,
  MeetingWithSchoolStaffAndFamilyMembers = 4,
  OnSiteObservationOrSupervisionOfAProvider = 5,
  PreparationTime = 6,
  ProviderAbsentUnavailable = 7,
  TimeSpentEnteringSessionNotes = 8,
  TimeSpentProgressReporting = 9,
  NotApplicable = 999
}